export default "__VITE_ASSET__DxTYTiUI__"